module.exports = __webpack_public_path__ + "static/media/verify.8559beab.svg";